import { authActions } from '../actions'
import { FETCHING_HEADERS } from '../actions/auth'
const { FETCH_HEADERS, FETCH_HEADERS_ERROR, CLEAR_HEADERS } = authActions

const initialState = {
  tokenType: '',
  accessToken: '',
  client: '',
  expiry: '',
  uid: '',
  is_fetching: false,
  fetch_error: false,
  fetch_error_message: '',
}

const headers = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_HEADERS:
      return { 
        ...initialState,
        is_fetching: true,
        fetch_error: false,
        fetch_error_message: ''
      }

    case FETCH_HEADERS:
      return {
        ...state,
        tokenType: action.tokenType,
        accessToken: action.accessToken,
        client: action.client,
        expiry: action.expiry,
        uid: action.uid,
        is_fetching: false,
        fetch_error: false,
        fetch_error_message: ''
      }
    
    case FETCH_HEADERS_ERROR:
      return {
        ...initialState,
        is_fetching: false,
        fetch_error: true,
        fetch_error_message: action.error
      }
    
    case CLEAR_HEADERS:
      return initialState

      default: 
        return state
  }
}

export default headers



// WEBPACK FOOTER //
// ./src/reducers/headers.js